import { render, staticRenderFns } from "./MessageManagementWrapper.vue?vue&type=template&id=5048e1ed"
import script from "./MessageManagementWrapper.vue?vue&type=script&lang=js"
export * from "./MessageManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports